import Axios from 'axios'
import {memberTypeUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_member_types (context) {
    Axios.get(memberTypeUrls.getAllMemberTypes).then(function (response) {
      context.commit('GET_ALL_MEMBER_TYPES', response.data)
    })
  },
  get_member_types (context, publicId) {
    Axios.get(memberTypeUrls.getMemberTypes + publicId).then(function (response) {
      context.commit('GET_MEMBER_TYPES', response.data)
    })
  },
  get_member_genders (context) {
    Axios.get(memberTypeUrls.getMemberGenders).then(function (response) {
      context.commit('GET_GENDERS', response.data)
    })
  },
  get_deleted_member_types (context) {
    Axios.get(memberTypeUrls.getDeletedMemberType).then(function (response) {
      context.commit('GET_DELETED_MEMBER_TYPES', response.data)
    })
  },
  get_member_type (context, publicId) {
    Axios.get(memberTypeUrls.getMemberType + publicId).then(function (response) {
      context.commit('GET_MEMBER_TYPE', response.data)
    })
  },
  post_member_type (context, data) {
    Axios.post(memberTypeUrls.postMemberType, data).then(function () {
      context.dispatch('get_all_membership_settings')
      return true
    }).catch(function (error) {
     
    })
  },
  update_member_type (context, data) {
    Axios.patch(memberTypeUrls.editMemberType, data).then(function () {
      context.dispatch('get_all_membership_settings')
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
    })
  },
  delete_member_type (context, publicId) {
    Axios.get(memberTypeUrls.deleteMemberType + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_DELETED_MEMBER_TYPES', response.data)
      router.push({
        name: 'Module.DeletedMemberTypes'
      })
    })
  },
  restoreMemberType (context, publicId) {
    Axios.get(memberTypeUrls.restoreMemberType + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_MEMBER_TYPES', response.data)
      router.push({
        name: 'Module.MemberTypes'
      })
    })
  }
}
